import {
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  FilterType,
  SortDirection,
  UserPermission
} from '@globaleris/ui.library'
import { Delete, Edit } from '@material-ui/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ProductPriceModel } from '../../../../../api/Argentia/endpoints/products/model/products'
import { EnumTipoCPrecio } from '../../../../../api/oData/enums/enumTipoCPrecio'
import { enumToSelectOptionArray } from '../../../../../helpers'
import { getCustomerDomain } from '../../../../../redux'

interface ProductPriceTableModel extends ProductPriceModel {
  priceContractCodeDesc: string
}

interface ProductPriceTableProps {
  data: ProductPriceModel[]
  onRowInsert: () => void
  onRowEdit: (selectedRow: ProductPriceModel) => void
  onRowDelete: (selectedRow: ProductPriceModel) => void
}

export const ProductPriceTable: React.FC<ProductPriceTableProps> = ({
  data,
  onRowInsert,
  onRowEdit,
  onRowDelete
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'products', 'enums'])

  // #region Handlers Starts
  const handleAddPriceComponentType = async () => {
    onRowInsert()
    return true
  }

  const handleEditPriceComponentType = (selectedRow: ProductPriceModel) => {
    onRowEdit(selectedRow)
  }

  const handleDeletePriceComponentType = (selectedRow: ProductPriceModel) => {
    onRowDelete(selectedRow)
  }
  // #endregion Handlers Ends

  // #region Functions Starts
  const mapToProductPriceTableModel = (rows: ProductPriceModel[]): ProductPriceTableModel[] =>
    rows.map(row => ({
      ...row,
      regenerate: !!row.regenerate,
      priceContractCodeDesc: row.priceContract
        ? `${row.priceContract.code} - ${row.priceContract.description}`
        : ''
    }))

  console.log(mapToProductPriceTableModel(data))
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  const options: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    search: true,
    elevation: 0,
    filterType: FilterType.ADVANCED,
    download: true,
    canEdit: false,
    canDelete: false,
    canInsert: true,
    customInsertEditModal: true,
    pagination: true,
    analytics: {
      customer: getCustomerDomain(),
      view: t('products:components.productPriceTable.dataTable.analytics')
    },
    sortOrder: {
      name: 'price.code',
      direction: SortDirection.ASC
    },
    onRowInsert: handleAddPriceComponentType,
    rowCustomActions: [
      {
        icon: <Edit fontSize="small" />,
        tooltip: t('products:components.productPriceTable.dataTable.tooltips.edit'),
        onClick: handleEditPriceComponentType,
        userPermission: UserPermission.EDIT
      },
      {
        icon: <Delete fontSize="small" />,
        tooltip: t('products:components.productPriceTable.dataTable.tooltips.delete'),
        onClick: handleDeletePriceComponentType,
        userPermission: UserPermission.EDIT
      }
    ]
  }

  const columns: DataTableColumn[] = [
    {
      name: 'id',
      display: false
    },
    {
      name: 'price.code',
      label: t('products:components.productPriceTable.dataTable.columns.code'),
      type: DataType.TEXT
    },
    {
      name: 'price.description',
      label: t('products:components.productPriceTable.dataTable.columns.description'),
      type: DataType.TEXT
    },
    {
      name: 'price.priceDummy.expression',
      label: t('products:components.productPriceTable.dataTable.columns.expression'),
      type: DataType.TEXT,
      columnWidth: 300
    },
    {
      name: 'type',
      label: t('products:components.productPriceTable.dataTable.columns.type'),
      selectOptions: enumToSelectOptionArray(EnumTipoCPrecio, 'enums:EnumTipoCPrecio'),
      type: DataType.SELECT
    },
    {
      name: 'priceContractCodeDesc',
      label: t('products:components.productPriceTable.dataTable.columns.priceContractCodeDesc'),
      type: DataType.TEXT
    },
    {
      name: 'regenerate',
      label: t('products:components.productPriceTable.dataTable.columns.regenerate'),
      type: DataType.BOOLEAN
    }
  ]

  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <>
      <DataTable data={mapToProductPriceTableModel(data)} columns={columns} options={options} />
    </>
  )
}
